import { AddressSelectionContextState } from './address-selection-types';

export const initialAddressSelectionState: AddressSelectionContextState = {
  contacts: [],
  count: 1,
  maxCount: 0,
  isMaxCountReached: false,
};
